import { handleActions } from "redux-actions";
import {
    clearMetric,
    clearMetricData,
    clearTask,
    getMetricDataByTask,
    getMetricDataByTaskError,
    getMetricDataByTaskSuccess,
    getMetricTasks,
    getMetricTasksError,
    getMetricTasksSuccess,
    getTaskByCode,
    getTaskByCodeError,
    getTaskByCodeSuccess,
    mergeUpdateMetricTaskDialog,
    setMetricGraphDialog,
    setPercentProgress,
    setUpdateMetricTaskDialog,
    updateMetric
} from "modules/Metric/services/dashboard/actions";

const initialState = {
    code: null,
    lastStartAt: null,
    percentProgress: 0,
    currentTask: {
        isLoading: false,
        task: {}
    },
    updatingDialog: {
        isOpen: false,
        isLoading: false,
        status: null
    },
    graphDialog: {
        isOpenOneChart: false,
        isOpenMultiCharts: false,
        title: "",
        taskName: "",
        labels: [],
        inputData: [],
        branchCode: null,
    },
    tasks: {
        isLoading: false,
        metricTasks: {},
        codes: [],
        count: 0
    },
    data: {
        isLoading: false,
        reportData: []
    }
};

export const dashboardReducer = handleActions(
    {
        [clearMetric]: () => ({ ...initialState }),

        [setUpdateMetricTaskDialog]: (state, { payload }) => ({
            ...state,
            updatingDialog: {
                ...initialState.updatingDialog,
                ...payload
            }
        }),

        [setMetricGraphDialog]: (state, { payload }) => ({
            ...state,
            graphDialog: {
                ...initialState.graphDialog,
                ...payload
            }
        }),
        [mergeUpdateMetricTaskDialog]: (state, { payload }) => ({
            ...state,
            updatingDialog: {
                ...state.updatingDialog,
                ...payload
            }
        }),

        [updateMetric]: (state, { payload }) => ({
            ...state,
            ...payload
        }),

        [getMetricTasks]: (state) => ({
            ...state,
            tasks: {
                ...initialState.tasks,
                isLoading: true
            }
        }),
        [getMetricTasksSuccess]: (state, { payload }) => ({
            ...state,
            tasks: {
                ...state.tasks,
                ...payload,
                isLoading: false
            }
        }),
        [getMetricTasksError]: (state) => ({
            ...state,
            tasks: {
                ...state.tasks,
                isLoading: false
            }
        }),

        [setPercentProgress]: (state, { payload }) => ({
            ...state,
            percentProgress: payload
        }),

        [clearMetricData]: (state) => ({
            ...state,
            data: { ...initialState.data }
        }),

        [getMetricDataByTask]: (state) => ({
            ...state,
            data: {
                ...state.data,
                isLoading: true
            }
        }),
        [getMetricDataByTaskSuccess]: (state, { payload }) => ({
            ...state,
            percentProgress: 0,
            data: {
                ...state.data,
                reportData: payload,
                isLoading: false
            }
        }),
        [getMetricDataByTaskError]: (state) => ({
            ...state,
            data: {
                ...state.data,
                isLoading: false
            }
        }),

        [clearTask]: (state) => ({
            ...state,
            currentTask: {
                task: {},
                isLoading: false
            }
        }),
        [getTaskByCode]: (state) => ({
            ...state,
            currentTask: {
                ...state.currentTask,
                isLoading: true
            }
        }),
        [getTaskByCodeSuccess]: (state, { payload }) => ({
            ...state,
            percentProgress: 0,
            currentTask: {
                task: payload,
                isLoading: false
            }
        }),
        [getTaskByCodeError]: (state) => ({
            ...state,
            currentTask: {
                ...state.currentTask,
                isLoading: false
            }
        })
    },
    initialState
);
